import "bootstrap/dist/css/bootstrap.min.css";
import React, { useEffect, useState } from "react";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import Header_Home from "../Component/Header_Home.js";
import Header from "../Component/Header.js";
import "../../App.css";
import "react-datepicker/dist/react-datepicker.css";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import "../LetterDigiCom/letterDigiCom-styles.css";
import Skeleton from "react-loading-skeleton";
import "moment/locale/th";
import CircularProgress from "@mui/material/CircularProgress";
import { Modal, Col, Button } from "react-bootstrap";
import Row from "react-bootstrap/Row";
import { useNavigate, useSearchParams } from "react-router-dom";
import styles from "./changeModePay-styles.module.css";
import {
  Grid,
  Typography,
  Card,
  CardContent,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Box,
  IconButton,
  Stack,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormGroup,
  Backdrop,
  Checkbox,
} from "@mui/material";

import { MdCalendarToday } from "react-icons/md";
import ScrollableModePay from "./ScrollableModePay.js";
import { useSwipeable } from "react-swipeable";
import {
  getPersonalChangePaymentModeAPI,
  getPersonalPhoneAPI,
  getUserProfileAPI,
  updatePersonalChangePaymentModeAPI,
  updatePersonalEmailAPI,
  updatePersonalPhoneAPI,
} from "../Personal/PersonalService/personalService.js";
import AssignmentTurnedInRoundedIcon from "@mui/icons-material/AssignmentTurnedInRounded";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";
import { CardHeader } from "@mui/material";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import successGif from "../../images/successGiff.gif";
import { toast, ToastContainer } from "react-toastify";
import { requestOtpAPI } from "../changePay/changePayService/changePayService";
import CryptoJS from "crypto-js";
import ContactModal from "../Component/ContactModal";
import remove from "../../images/remove.png";
import { Modal as BootstrapModal } from "react-bootstrap";

const ChangeModePay = () => {
  const theme = createTheme({
    components: {
      MuiTableHead: {
        styleOverrides: {
          root: {},
        },
      },
    },
  });

  const [loading, setLoading] = useState(false);
  const [LoadingContent, setLoadingContent] = useState(false);
  const [activeTab, setActiveTab] = useState();
  const [cusTel, setCusTel] = useState("");
  let [searchParams, setSearchParams] = useSearchParams();
  const policyNo = searchParams.get("policyNo") || "";
  let navigate = useNavigate();
  const [policiesData, setPoliciesData] = useState([]);
  const [option, setOption] = useState([]);
  const [listData, setListData] = useState([]);
  const [inputData, setInputData] = useState([{}]);
  const [mobilePhone, setMobilePhone] = useState();
  const [step, setStep] = useState(1);
  const [selectedValue, setSelectedValue] = useState();
  const [otp, setOtp] = useState("");
  const [hasSelectedItems, setHasSelectedItems] = useState(false);
  const [completedModal, setCompletedModal] = useState(false);
  const [textModal, setTextModal] = useState("");
  const [toggleImg, setToggleImg] = useState(false);
  const [openContactModal, setOpenContactModal] = useState(false);

  // Mapping for payment period codesต
  const paymentPeriodMap = {
    M: "รายเดือน",
    U: "รายสามเดือน",
    S: "รายหกเดือน",
    A: "รายปี",
  };

  // Function to translate payment period codes to Thai
  const translatePaymentPeriod = (period) => {
    if (!period) return "-";
    if (Array.isArray(period)) {
      return period.map((p) => paymentPeriodMap[p] || p).join(", ");
    }
    return paymentPeriodMap[period] || period;
  };

  const goBack = () => {
    if (step == 2) {
      setStep(1);
    } else if (step == 3) {
      setStep(2);
    } else {
      navigate("/personal");
    }
  };

  const goNext = () => {
    if (step == 1) {
      if (!hasSelectedItems) {
        showWarn("กรุณาเลือกกรมธรรม์อย่างน้อย 1 รายการ");
        return;
      } else if (!selectedValue) {
        showWarn("กรุณาเลือกงวดการชำระเบี้ย");
        return;
      } else {
        setStep(2)
      }
    } else if (step == 2) {
      handleReqOtp();
      setStep(3);
    } else if (step == 3) {
      submitChangePayMode();
      // setStep(4);
    }
  };

  const showWarn = (msg) => {
    setTextModal(msg);
    setToggleImg(false);
    setCompletedModal(true);
  };

  useEffect(() => {
    setLoading(true);
    getUserProfileAPI()
      .then((res) => {
        setLoading(false);
        if (res.success == "true") {
          if (res.payload.profile == "POS2") {
            // window.location.href = "/home";
            navigate("/home");
          }
        }
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
        // setCompletedModal(true);
      });
    // get Personal Phone
    getPersonaChangePaymentMode();

    return () => {
      // console.log("useEffect return unmount >>>");
    };
  }, []);

  const styleDrive = {
    py: 0,
    width: "100%",
    maxWidth: "auto",
    borderColor: "divider",
    backgroundColor: "background.paper",
  };

  const ScrollableCardInformation = () => {
    const cardRef = React.useRef(null);
  
    const handlers = useSwipeable({
      onSwiped: (eventData) => {
        if (cardRef.current) {
          cardRef.current.scrollTop += -eventData.deltaY;
        }
      },
      delta: 10,
      trackMouse: true,
    });
  
    // ✅ ใช้เฉพาะกรมธรรม์ที่เลือก
    const selectedPolicies = Array.isArray(listData) ? listData : [];
    console.log(selectedPolicies);
  
    return (
      <Card
        sx={{
          maxHeight: "510px",
          overflowY: "hidden",
          border: "1px solid rgba(255, 94, 67, 0.3) !important", // สีของขอบ #FF5E43 ที่โปร่งใส 30%
          borderRadius: "12px !important", // ความโค้งของขอบ
          borderWidth: "2px !important",
          display: "flex",
          flexDirection: "column",
          boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
          width: "100%", // เพิ่มความกว้างให้เต็ม 100%
          mx: "auto", // Center the card horizontally
          px: 2, // Add horizontal padding
        }}
        ref={cardRef}
        {...handlers} // ผูกฟังก์ชันสไวป์ให้กับการ์ด
      >

        <CardContent sx={{ cursor: "pointer", overflowY: "auto", boxSizing: "border-box" }}>
  
          {selectedPolicies.length === 0 ? (
            <Typography sx={{ p: 2, textAlign: "center" }}>ยังไม่เลือกกรมธรรม์</Typography>
          ) : (
            selectedPolicies.map((item, index) => {
              const policyNo = item.policy_no ?? item.policyNo;
              const baseName  = item.base_name ?? item.baseName ?? "-";
  
              return (
                <Box key={policyNo ?? index} sx={{ mb: "15px", p: "10px", transition: "background-color .3s, border .3s" }}>
                  <List sx={styleDrive} style={{ marginBottom: "30px" }}>
                    <ListItem><ListItemText primary="กรุณาตรวจสอบข้อมูล" /></ListItem>
                    <Divider variant="middle" component="li" />
                  </List>
  
                  <Card sx={{ border: "1px solid rgba(255, 94, 67, 0.3) !important", borderRadius: "12px !important", borderWidth: "2px !important", mx: "auto", px: 1, pr: 0, pl: 0 }}>
                    <CardHeader
                      title={
                        <Box>
                          <Typography sx={{ fontFamily: '"Prompt-Thin", sans-serif !important', fontSize: { xs: "14px", sm: "15px" }, fontWeight: "medium", color: "black", ml: "15px" }}>
                            กรมธรรม์เลขที่ : {policyNo}
                          </Typography>
                          <Typography sx={{ fontFamily: '"Prompt-Thin", sans-serif !important', fontSize: { xs: "13px", sm: "14px" }, color: "black", ml: "15px", mt: "5px", whiteSpace: "normal", wordBreak: "break-word", lineHeight: 1.4 }}>
                            แบบประกัน : {baseName}
                          </Typography>
                        </Box>
                      }
                      sx={{ backgroundColor: "rgba(255, 94, 67, 0.3)" }}
                    />
  
                    <CardContent>
                      <Typography>
                        <Grid container spacing={1}>
                          <Grid item xs={7} sm={4} md={2} lg={3} xl={3}>
                            <span className="font-size-label-pol">งวดการชำระเบี้ย :</span>
                          </Grid>
                          <Grid item xs={5} sm={5} md={2} lg={2} xl={2}>
                            <span className="font-size-label-pol">{translatePaymentPeriod(selectedValue)}</span>
                          </Grid>
                        </Grid>
                      </Typography>
                    </CardContent>
                  </Card>
                </Box>
              );
            })
          )}
  
        </CardContent>
      </Card>
    );
  };
  

  const decryptCardNumber = (encryptedCardNumber, secretKey) => {
    const bytes = CryptoJS.AES.decrypt(encryptedCardNumber, secretKey);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    return decrypted;
  };

  const getPersonaChangePaymentMode = () => {
    setLoading(true);
    setLoadingContent(true);

    getPersonalChangePaymentModeAPI(
      decryptCardNumber(
        localStorage.getItem("customer_id"),
        process.env.REACT_APP_ENCRYPT_DATA
      )
    )
      .then((res) => {
        setLoading(false);
        setLoadingContent(false);

        if (res.status) {
          let option = [];

          if (res.data.policies && res.data.policies.length > 0) {
            res.data.policies.map((item, idx) => {
              console.log("res.payload", item);
              let dataTmp = {
                label: item.policy_no,
                id: idx,
              };
              option.push(dataTmp);
            });
            setOption(option);
            setPoliciesData(res.data.policies);
          } else {
            // No data case
            setOption([]);
            setPoliciesData([]);
          }
        } else {
          // API returned error status
          setOption([]);
          setPoliciesData([]);
        }
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
        setLoadingContent(false);
        setOption([]);
        setPoliciesData([]);
      });
  };

  const resendOtp = () => {
    handleReqOtp();
  };

  const submitChangePayMode = async () => {
    // Check if listData is empty or doesn't have the expected structure
    if (!listData || listData.length === 0) {
      console.error("No policy selected");
      notifyError("กรุณาเลือกกรมธรรม์");
      return;
    }

    // Check if the required properties exist
    if (!listData[0].policy_no) {
      console.error("Policy number is missing");
      notifyError("ข้อมูลกรมธรรม์ไม่ถูกต้อง");
      return;
    }

    const payload = {
      policyNo: listData[0].policy_no,
      currentPayMode: listData[0].currentMode || "",
      requestPayModeCode: selectedValue, // Use the original code instead of the translated text
      requestPayMode: translatePaymentPeriod(selectedValue),
      otp: otp,
      citizenId: decryptCardNumber(
        localStorage.getItem("customer_id"),
        process.env.REACT_APP_ENCRYPT_DATA
      ),
    };
    console.log("Submitting payload:", payload);
    updatePersonalChangePaymentModeAPI(payload)
      .then((res) => {
        console.log("API response:", res);
        setStep(4);
      })
      .catch((err) => {
        console.error("API error:", err);
        notifyError("เกิดข้อผิดพลาดในการเปลี่ยนงวดการชำระเบี้ย");
      });
  };

  const notifySuccess = (title) => {
    toast.success(title, {
      position: "top-center",
    });
  };

  const notifyError = (title) => {
    toast.error(title, {
      position: "top-center",
    });
  };

  const handleReqOtp = async () => {
    const resultReqOtp = await requestOtpAPI("CHANGE_MODE_PAY");
    if (resultReqOtp.status === true) {
      notifySuccess(resultReqOtp.meg);
    } else {
      notifyError(resultReqOtp.meg);
    }
  };

  return (
    <div>
      <Header_Home />
      <Header title="เปลี่ยนงวดการชำระเบี้ย" />
      {loading && (
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loading}
          // onClick={handleClose}
        >
          <CircularProgress
            sx={{
              animationDuration: "550ms",
            }}
            color="inherit"
          />
        </Backdrop>
      )}

      {/* <div className="frame-loan p-4"> */}
      <div className="containers p-4">
        {LoadingContent && (
          <>
            <Row className="card-custom3 d-flex">
              <Col className="mt-3">
                <Skeleton style={{ height: "30px" }} />
                <div className="d-flex flex-row justify-content-between">
                  <Skeleton />
                </div>
                <Skeleton />
                <Skeleton />
                <Skeleton />
                <Skeleton />
                <Skeleton />
                <Skeleton />
                <Skeleton />
                <Skeleton />
              </Col>
            </Row>
            <br />
          </>
        )}
        {!LoadingContent && (
          <>
            {/* STEP 1: เลือกโหมดการชำระเบี้ย */}
            {step === 1 && (
              <>
                <Typography sx={{ fontWeight: "bold", mb: 1 }}>
                  เลือกกรมธรรม์
                </Typography>

                {policiesData && policiesData.length > 0 ? (
                  <ScrollableModePay
                    policiesData={policiesData}
                    setPoliciesData={setPoliciesData}
                    listData={listData}
                    inputData={inputData}
                    setListData={setListData}
                    mobilePhone={mobilePhone}
                    onSelectionChange={setHasSelectedItems}
                  />
                ) : (
                  <Paper
                    elevation={0}
                    sx={{
                      border: "1px solid rgba(255, 94, 67, 0.3) !important",
                      borderRadius: "12px !important",
                      borderWidth: "2px !important",
                      p: 3,
                      mb: 3,
                      textAlign: "center",
                      width: "100%",
                      mx: "auto",
                    }}
                  >
                    <Typography sx={{ fontSize: "16px", color: "#555" }}>
                      ไม่พบข้อมูลกรมธรรม์
                    </Typography>
                  </Paper>
                )}
                <br />
                {hasSelectedItems && (
                  <Box sx={{ p: 2, paddingLeft: 0, paddingRight: 0 }}>
                    {/* กล่องโหมดการชำระเบี้ย */}
                    <Paper
                      elevation={0}
                      sx={{
                        border: "1px solid rgba(255, 94, 67, 0.3) !important", // สีของขอบเหมือนกับ Card
                        borderRadius: "12px !important", // ความโค้งของขอบเหมือนกับ Card
                        borderWidth: "2px !important", // ความหนาของขอบเหมือนกับ Card
                        p: 2,
                        mb: 1,
                        width: "100%", // เพิ่มความกว้างให้เท่ากับ Card
                        mx: "auto", // Center the paper horizontally
                        px: 2, // Add horizontal padding
                      }}
                    >
                      <Stack
                        direction="row"
                        alignItems="center"
                        spacing={1}
                        mb={2}
                      >
                        <MdCalendarToday size={20} />
                        <Typography
                          variant="subtitle1"
                          sx={{ fontWeight: "bold", fontFamily: "Prompt-Thin" }}
                        >
                          งวดการชำระเบี้ย
                        </Typography>
                      </Stack>

                      <RadioGroup
                        sx={{
                          color: "#000000",
                          "&.Mui-checked": {
                            color: "#f2654e",
                          },
                        }}
                        value={selectedValue}
                        onChange={(e) => setSelectedValue(e.target.value)}
                      >
                        {console.log("policiesData", policiesData)}
                        <Grid container spacing={2} sx={{ ml: 1 }}>
                          {policiesData.length > 0 ? (
                            Array.isArray(
                              policiesData[0].changePaymentModePeriod
                            ) ? (
                              // If changePaymentModePeriod is an array, map through it
                              policiesData[0].changePaymentModePeriod.map(
                                (period, idx) => (
                                  <Grid item xs={6} key={idx}>
                                    <FormControlLabel
                                      value={period}
                                      control={
                                        <Radio
                                          sx={{
                                            color: "#000000",
                                            "&.Mui-checked": {
                                              color: "#f2654e",
                                            },
                                          }}
                                        />
                                      }
                                      label={translatePaymentPeriod(period)}
                                    />
                                  </Grid>
                                )
                              )
                            ) : (
                              // If changePaymentModePeriod is a single value
                              <Grid item xs={6}>
                                ไม่พบข้อมูล
                              </Grid>
                            )
                          ) : (
                            // Fallback to default options if no changePaymentModePeriod data
                            <>
                              <Grid item xs={6}>
                                ไม่พบข้อมูล
                              </Grid>
                              {/* <Grid item xs={6}>
                                    <FormControlLabel
                                      value="M"
                                      control={
                                        <Radio
                                          sx={{
                                            color: "#000000",
                                            "&.Mui-checked": {
                                              color: "#f2654e",
                                            },
                                          }}
                                        />
                                      }
                                      label={paymentPeriodMap["M"]}
                                    />
                                  </Grid>
                                  <Grid item xs={6}>
                                    <FormControlLabel
                                      value="U"
                                      control={
                                        <Radio
                                          sx={{
                                            color: "#000000",
                                            "&.Mui-checked": {
                                              color: "#f2654e",
                                            },
                                          }}
                                        />
                                      }
                                      label={paymentPeriodMap["U"]}
                                    />
                                  </Grid>
                                  <Grid item xs={6}>
                                    <FormControlLabel
                                      value="S"
                                      control={
                                        <Radio
                                          sx={{
                                            color: "#000000",
                                            "&.Mui-checked": {
                                              color: "#f2654e",
                                            },
                                          }}
                                        />
                                      }
                                      label={paymentPeriodMap["S"]}
                                    />
                                  </Grid>
                                  <Grid item xs={6}>
                                    <FormControlLabel
                                      value="A"
                                      control={
                                        <Radio
                                          sx={{
                                            color: "#000000",
                                            "&.Mui-checked": {
                                              color: "#f2654e",
                                            },
                                          }}
                                        />
                                      }
                                      label={paymentPeriodMap["A"]}
                                    />
                                  </Grid> */}
                            </>
                          )}
                        </Grid>
                      </RadioGroup>
                    </Paper>
                  </Box>
                )}

                <br />
                <Typography
                  sx={{
                    color: "red",
                    fontSize: "0.875rem",
                    whiteSpace: "pre-line",
                    mt: 1,
                    ml: 1,
                    fontFamily: "Prompt-Regular",
                  }}
                >
                  หมายเหตุ :
                  <br />
                  1. ท่านสามารถส่งคำร้องขอเปลี่ยนงวดการชำระเบี้ยประกันภัยล่วงหน้าได้ 30 วัน
                  <br />
                  ก่อนถึงวันครบกำหนดชำระเบี้ยประกันภัยในงวดปัจจุบัน
                  <br />
                  2. ในกรณีที่บริษัทฯ ดำเนินการตัดชำระค่าเบี้ยประกันภัยผ่านบัตรเครดิตของท่านแล้ว การขอเปลี่ยนแปลงในครั้งนี้
                  <br />
                  จะมีผลในงวดชำระเบี้ยครั้งถัดไป
                  <br />
                  3. สามารถสอบถามค่าเบี้ยประกันภัยการเปลี่ยนแปลงงวดการชำระได้ที่
                  <span
                    onClick={() => setOpenContactModal(true)}
                    style={{
                      color: "#FF5E43",
                      textDecoration: "underline",
                      cursor: "pointer",
                      fontWeight: "bold",
                    }}
                  >
                    ฝ่ายลูกค้าสัมพันธ์
                  </span>
                </Typography>
              </>
            )}

            {/* STEP 2: หน้ายืนยันข้อมูล */}
            {step === 2 && (
              <>
                <Box sx={{ p: 2 }}>
                  <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                    <AssignmentTurnedInRoundedIcon
                      fontSize="large"
                      style={{ color: "rgb(255, 94, 67)" }}
                    />
                    <Typography sx={{ fontSize: "20px", marginLeft: "10px" }}>
                      ยืนยันข้อมูล
                    </Typography>
                  </Box>
                </Box>

                <ScrollableCardInformation />
              </>
            )}

            {/* STEP 3: หน้ายืนยัน OTP */}
            {step === 3 && (
              <Box sx={{ p: 1, margin: "auto" }}>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: "bold",
                    mb: 2,
                    display: "flex",
                    alignItems: "center",
                    fontFamily: "Prompt-Thin",
                  }}
                >
                  <VerifiedUserIcon sx={{ color: "#FF5E43", mr: 1 }} />
                  ยืนยัน OTP
                </Typography>

                <Paper
                  elevation={0}
                  sx={{
                    border: "1px solid #e0e0e0",
                    borderRadius: 3,
                    p: 3,
                    mb: 3,
                    textAlign: "center",
                    mx: "auto", // Center the paper horizontally
                    px: 2, // Add horizontal padding
                  }}
                >
                  <Typography sx={{ mb: 2, textAlign: "left" }}>
                    กรุณาใส่หมายเลข OTP 6 หลัก
                    <br />
                    ที่ส่งไปยังเบอร์มือถือท่าน
                  </Typography>
                  <input
                    placeholder="OTP"
                    maxLength={6}
                    style={{
                      padding: "10px 20px",
                      borderRadius: "30px",
                      border: "1px solid #ccc",
                      fontSize: 18,
                      width: "100%",
                      outline: "none",
                      marginBottom: 8,
                    }}
                    value={otp}
                    onChange={(e) => {
                      const onlyNums = e.target.value.replace(/\D/g, "");
                      setOtp(onlyNums);
                    }}
                  />
                  <div
                    style={{
                      flex: 1,
                      flexDirection: "column",
                      justifyContent: "start",
                      alignItems: "flex-start", // ✅ ให้ชิดซ้าย
                      width: "100%",
                      marginTop: 10,
                    }}
                  >
                    <div
                      className="font-size-content-otp"
                      style={{ fontSize: "14px", textAlign: "left" }} // ✅ กันพลาดเพิ่ม textAlign ด้วย
                    >
                      ส่งรหัสผ่านไปที่หมายเลข{" "}
                      {localStorage.getItem("mobile_tel")
                        ? localStorage
                            .getItem("mobile_tel")
                            .replace(/(\d{3})(\d{4})(\d{3})/, "$1xxxx$3")
                        : ""}
                    </div>
                    <div
                      className="font-size-content-otp"
                      style={{ fontSize: "14px", textAlign: "left" }}
                    >
                      กรณีไม่ได้รับหรือเปลี่ยนหมายเลขโทรศัพท์มือถือ
                    </div>
                    <div
                      className="font-size-content-otp"
                      style={{ fontSize: "14px", textAlign: "left" }}
                    >
                      กรุณา
                      <span
                        onClick={() => setOpenContactModal(true)}
                        style={{
                          color: "#FF5E43",
                          textDecoration: "underline",
                          cursor: "pointer",
                          fontWeight: "bold",
                        }}
                      >
                        ติดต่อฝ่ายลูกค้าสัมพันธ์
                      </span>
                    </div>
                  </div>
                  <Typography
                    sx={{
                      color: "#f2654e",
                      fontSize: 14,
                      mt: 1,
                      cursor: "pointer",
                      textAlign: "left",
                    }}
                    onClick={resendOtp}
                  >
                    ส่งรหัส OTP อีกครั้ง?
                  </Typography>
                </Paper>
              </Box>
            )}
            {/* STEP 4:*/}
            {step === 4 && (
              <>
                <Box
                  sx={{
                    border: "1px solid #ccc",
                    borderRadius: "12px",
                    padding: 4,
                    backgroundColor: "#fff",
                    textAlign: "center",
                    mx: "auto", // Center the box horizontally
                    px: 2, // Add horizontal padding
                  }}
                >
                  <img
                    src={successGif} // ✅ เปลี่ยน path ให้ถูกต้องตามที่คุณเก็บรูปไว้
                    alt="Success"
                    style={{ width: "80px", marginBottom: "20px" }}
                  />
                  <Typography
                    sx={{
                      fontSize: "18px",
                      fontWeight: "bold",
                      fontFamily: "Prompt, sans-serif",
                      color: "#000",
                      whiteSpace: "pre-line",
                    }}
                  >
                    การเปลี่ยนแปลงดังกล่าว จะมีผลในงวดถัดไป
                    <br />
                    หากท่านต้องการให้ตัดชำระเบี้ยในงวดปัจจุบัน
                    <br />
                    โปรด
                    <span
                      onClick={() => setOpenContactModal(true)}
                      style={{
                        color: "#FF5E43",
                        textDecoration: "underline",
                        cursor: "pointer",
                        fontWeight: "bold",
                      }}
                    >
                      ติดต่อฝ่ายลูกค้าสัมพันธ์
                    </span>
                  </Typography>
                </Box>
              </>
            )}
          </>
        )}

        <br />

        <section className="action-address">
          <Grid
            container
            spacing={2}
            justifyContent="center" // จัดตำแหน่งตรงกลางแนวนอน
            alignItems="center" // จัดตรงกลางแนวตั้ง
            sx={{ minHeight: "10vh" }} // ให้ Grid เต็มความสูงหน้าจอ
          >
            <Grid
              container
              justifyContent="center" // Keep buttons centered
              alignItems="center"
              sx={{ minHeight: "10vh" }}
            >
              <Grid item sx={{ mr: 1 }}>
                {" "}
                {/* Add margin to the right */}
                <button
                  onClick={goBack}
                  className="btn-address-back p-2 bold"
                  style={{ minWidth: "120px" }}
                >
                  {step === 4 ? "กลับสู่หน้าหลัก" : "ย้อนกลับ"}
                </button>
              </Grid>
              {step !== 4 && ( // Don't show Next button on the final step
                <Grid item sx={{ ml: 1 }}>
                  <button
                    onClick={goNext}
                    className="btn-address-next p-2 bold"
                    style={{
                      minWidth: "120px",
                      backgroundColor: "#f2654e",
                      color: "white",
                      border: "none",
                      borderRadius: "16px",
                      fontWeight: "bold",
                    }}
                  >
                    {step === 3 ? "บันทึก" : "ต่อไป"}
                  </button>
                </Grid>
              )}
            </Grid>
          </Grid>
        </section>
      </div>
      <BootstrapModal
        show={completedModal}
        backdrop="static"
        // size="md"
        // style={{}}
        className="backdrop-alert"
        contentClassName="modal-alert"
      >
        <BootstrapModal.Body>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img
              src={toggleImg ? greenCheck : remove}
              alt="check-icon"
              className="modal-image-size"
            />
          </div>

          <li
            className="body-list-group"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Col
              xl={12}
              md={12}
              xs={12}
              style={{
                display: "flex",
                marginTop: 5,
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
              }}
            >
              <div className="font-modal">{textModal}</div>
            </Col>
          </li>
          <div className="d-flex justify-content-center flex-wrap">
            <button
              className="btn-checkout-modal w-20 p-2 bold"
              onClick={() => {
                if (toggleImg) {
                  navigate("/personal");
                } else {
                  setCompletedModal(false);
                }
              }}
            >
              กลับ
            </button>
          </div>
        </BootstrapModal.Body>
      </BootstrapModal>
      <ContactModal
        open={openContactModal}
        onClose={() => setOpenContactModal(false)}
      />
      {/* </div> */}
    </div>
  );
};

export default ChangeModePay;
